<template>
  <div id='map_canvas' class='googlemap'>

  </div>
</template>

<script>
import scheduleAPI from '@/modules/schedule/api/schedule';
import gmapsInit from '@/utils/gmaps';

export default {
  name: 'map-route',
  data: () => ({
    isLoading: false,
    route: [],
    map: null,
    google: null,
    markers: [],
  }),
  mounted() {
    this.setupData()
  },
  methods: {
    async setupData () {
      await this.getRoute()
      await this.initMap()
      await this.dropMarkers()
    },
    async getRoute() {
      this.route = await scheduleAPI.getRoute(this.$route.params.id)
    },
    async initMap() {
      try {
        this.google = await gmapsInit()
        let mapOptions = {
          center: new this.google.maps.LatLng(53.53, -113.5),
          zoom: 10,
          mapTypeId: this.google.maps.MapTypeId.ROADMAP,
          gestureHandling: 'greedy'
        }
        this.map = new this.google.maps.Map(document.getElementById('map_canvas'), mapOptions);
      } catch (error) {
        console.error(error);
      }
    },
    dropMarkers() {
      for (let i = 0; i < this.route.wos.length; i++) {
        window.setTimeout(() => {
          const latLng = new this.google.maps.LatLng(this.route.wos[i].project_lat, this.route.wos[i].project_lng)
          this.markers.push(
            new this.google.maps.Marker({
            position: latLng,
            animation: this.google.maps.Animation.DROP,
            label: { text: (i + 1).toString(), color: 'white' },
            title: this.route.wos[i].project_name + ' - ' + this.route.wos[i].project_site_address,
            map: this.map
          }))
        }, i * 200)
      }
    },
    clearMarkers() {
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];
    }
  }
}
</script>

<style scoped>

.googlemap {
  height: 100vh;
  width: 100%;
}

</style>